export const createThumbnail = (_options) =>
  Promise.reject(new Error('createThumbnail is not supported on web'));
